import PropTypes from "prop-types";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";
import { PDF_MIME_TYPE } from "constants/constants";

const ProfessionalReviews = ({ person, reviews, downloadReview }) => {
  const reviewYear = (review) => new Date(review.deadline).getFullYear();

  const onDownload = (review) => {
    const [id, extension, fileType] = review.pdf_id
      ? [review.pdf_id, "pdf", PDF_MIME_TYPE]
      : [review.docx_id, "docx"];

    downloadReview({
      id,
      fileName: `${person?.first_name}_${person?.last_name}_Bilans_${reviewYear(review)}.${extension}`,
      fileType,
    });
  };

  return (
    <div className="section-n">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="six_year_review_title"
            defaultMessage="Résumé bilans professionnels du salarié"
          />
        }
      />
      <div className="training-section">
        {reviews.map((review) => (
          <Button
            key={review.id}
            className="btn-standard btn-outline"
            type="button"
            onClick={() => onDownload(review)}
          >
            {reviewYear(review)}
          </Button>
        ))}
      </div>
    </div>
  );
};

ProfessionalReviews.propTypes = {
  person: PropTypes.object,
  reviews: PropTypes.array,
  downloadReview: PropTypes.func,
};

export default ProfessionalReviews;
